import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import i18next from 'i18next';
import logo from '../assets/Images/logo150.png';
import {SYSTEMS, getSystemUrl} from '../utils/gameSystem';
import {loadVtmFonts} from '../utils/vtmFonts';
import '../styles/systemPicker.css';

// Polices du dossier d'enquête, pour le panneau Cthulhu
const loadCthulhuFonts = () => {
  if (document.getElementById('cthulhu-fonts')) return;
  const link = document.createElement('link');
  link.id = 'cthulhu-fonts';
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Libre+Caslon+Text:ital@0;1&family=Special+Elite&display=swap';
  document.head.appendChild(link);
};

/** Accueil du domaine principal : choisir son jeu avant d'arriver sur ses campagnes. */
const SystemPicker = () => {
  useEffect(() => {
    loadVtmFonts();
    loadCthulhuFonts();
  }, []);

  return (
    <main className='systemPicker'>
      <Link className='systemPanel aria' to='/campaigns'>
        <div className='systemPanelContent'>
          <img className='systemPanelLogo' src={logo} alt='' />
          <span className='systemPanelKicker'>{i18next.t('home.ariaKicker')}</span>
          <h2 className='systemPanelTitle'>Aria</h2>
          <p className='systemPanelText'>{i18next.t('home.ariaText')}</p>
          <span className='systemPanelCta'>{i18next.t('home.play')} →</span>
        </div>
      </Link>

      <a className='systemPanel vtm' href={getSystemUrl(SYSTEMS.VTM5)}>
        <div className='systemPanelContent'>
          <svg className='systemPanelSigil' viewBox='0 0 48 48' aria-hidden='true'>
            <path d='M24 4 L42 24 L24 44 L6 24 Z' />
            <path d='M24 15 C 20 21, 18 24, 18 27.5 A6 6 0 0 0 30 27.5 C 30 24, 28 21, 24 15 Z' className='drop' />
          </svg>
          <span className='systemPanelKicker'>{i18next.t('home.vtmKicker')}</span>
          <h2 className='systemPanelTitle'>Vampire</h2>
          <p className='systemPanelText'>{i18next.t('home.vtmText')}</p>
          <span className='systemPanelCta'>{i18next.t('home.enter')} →</span>
        </div>
      </a>

      <div className='systemPanel cthulhu' aria-disabled='true'>
        <div className='systemPanelContent'>
          <svg className='systemPanelSigil' viewBox='0 0 48 48' aria-hidden='true'>
            <circle cx='24' cy='24' r='19' />
            <path d='M24 13 C 15 13, 12 20, 15 24 C 18 28, 30 28, 33 24 C 36 20, 33 13, 24 13 Z' />
            <path d='M18 27 C 16 32, 18 36, 15 39 M22 28 C 21 33, 23 36, 21 40 M26 28 C 27 33, 25 36, 27 40 M30 27 C 32 32, 30 36, 33 39' />
          </svg>
          <span className='systemPanelKicker'>{i18next.t('home.cthulhuKicker')}</span>
          <h2 className='systemPanelTitle'>Cthulhu</h2>
          <p className='systemPanelText'>{i18next.t('home.cthulhuText')}</p>
          <span className='systemPanelStamp'>{i18next.t('home.soon')}</span>
        </div>
      </div>

      <div className='systemPickerHeader'>
        <h1>Pray the Dice</h1>
        <p>{i18next.t('home.question')}</p>
      </div>
    </main>
  );
};

export default SystemPicker;
